module.exports = __webpack_public_path__ + "img/featuredartist (5).78823508.jpg";